import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { FORM_MSGS, MFA_FACTORS } from 'src/app/_common/product-config';
import { HeaderData } from 'src/app/_models/header-data';
import { CommonService } from 'src/app/_services/common.service';
import { StatusCode, FactorTypes, MfaStatus } from 'src/app/_common/_enum/module.enum';
import { AuthenticationComponent } from '../../login/authentication/authentication.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

  @ViewChild("changeForm", { static: false }) changeForm: NgForm;

  private loading: boolean = false; // Using it in HTML
  private errorMessage: string = ''; // Using it in HTML
  private userProfile: any;
  private mfaProfile: any;
  private user: any;
  private autoHideMsg: boolean = false;
  private isPasswordSave: boolean = false;
  private passwordContainsName: boolean = false;
  private passwordTooRecent: boolean = false;
  successMessage: string = '';
  private formMsgs = FORM_MSGS; // Using it in HTML
  private mfaOptions = MFA_FACTORS; // Using it in HTML

  private factorTypes = FactorTypes; // Using it in HTML
  private mfaStatus = MfaStatus; // Using it in HTML

  private phoneNumber: string = ''; // Using it in HTML
  private emailAddress: string = ''; // Using it in HTML

  private headerData: HeaderData;

  //private killServicesOnDestroy = [];

  @Input() public uid;
  @ViewChild(AuthenticationComponent, {static: false}) authentication:AuthenticationComponent;

  constructor(private authenticationService: AuthenticationService, private router: Router, private commonService: CommonService) { }

  ngOnInit() {
    this.authenticationService.authenticationScreen = false;
    this.authenticationService.factorVerified = false;

    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.getProfileData();
  }

  setHeaderData(){
    this.headerData.pageTitle = (this.authenticationService.authenticationScreen) ? "Two-Step Verification" : "User Profile";
    this.headerData.breadcrumb = null;
    this.headerData.detailMenu = null;

    this.commonService.header = this.headerData;
  }

  getProfileData() {
    this.resetAlertMessages();
    this.loading = true;
    let profileSubscription = this.authenticationService.profile().subscribe(data => {
      this.user = this.authenticationService.currentUser;
      this.userProfile = data;
      this.authenticationService.mfaProfile().subscribe(mfaData =>{
        this.loading = false;
        this.mfaProfile = mfaData;
        this.mfaProfile.forEach(factor => {
          this.mfaOptions.forEach(option =>{
            if(factor.userPreferred && factor.factorType == option.type){ this.authenticationService.preferredFactor = option; }
          })
        });
      },
      error => {
        this.loading = false;
        console.log('Error Occured!!! ');
      });
    },
    error => {
      this.loading = false;
      this.userProfile = null;
      console.log('Error Occured!!! ');
    });

    this.commonService.runningServices.push(profileSubscription);
  }

  changePassword() {
    this.resetAlertMessages();
    if (this.changeForm.valid && (this.changeForm['oldPassword'] !== this.changeForm['newPassword'])) {
      this.isPasswordSave = true;
      this.authenticationService.changePassword(this.changeForm['oldPassword'], this.changeForm['newPassword'], this.changeForm['confirmNewPassword']).subscribe(data => {
        this.isPasswordSave = false;
        this.autoHideMsg = false;
        this.successMessage = this.formMsgs.PasswordChanged;

        setTimeout(() => {
          this.autoHideMsg = true;
          this.changeForm.resetForm();
        }, 3000);
        
      },
      error => {
        this.isPasswordSave = false;
        this.autoHideMsg = false;
        console.log(error);

        if(error.error.errorContent.message == this.formMsgs.OldPasswordIncorrect) {
          this.errorMessage = this.formMsgs.IncorrectCurrentPassword;
        }
        else if(error.error.errorContent.message == this.formMsgs.PasswordContainsName){
          this.passwordContainsName = true;
        }
        else if(error.error.errorContent.message == this.formMsgs.PasswordTooRecent){
          this.passwordTooRecent = true;
        }
        else{
          this.errorMessage = this.formMsgs.SomethingWentWrong;
        }
      });
    }
  }

  editMfa(){
    this.authenticationService.authenticationScreen = true; 
    this.authenticationService.factorVerified = false;
    this.setHeaderData();
  }

  resetAlertMessages() {
    this.successMessage = "";
    this.errorMessage = "";
  }

  checkErrorMessages(){
    if(this.passwordContainsName || this.passwordTooRecent){ return true; } 
    else { return false;  }
  }

  resetPasswordRules(){
    this.passwordContainsName = false;
    this.passwordTooRecent = false;
  }

  get isProsightUser() {
    return this.userProfile.userTypeID !== 1;
  }

  ngOnDestroy() {
    this.commonService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
